import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitized'
})
export class SanitizedPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  public transform(value: any): SafeHtml {
    const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, value);
    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }
}
